import { Activity } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const ActivityIcon = DeckardIconWrapper({ Icon: Activity });
